<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-tabs v-model="activeName">
            <el-tab-pane label="试卷管理" name="first">
              <el-form :inline="true" size="small" @submit.native.prevent>
                <el-form-item label="名称">
                  <el-input v-model="paperSearchForm.name" clearable placeholder="关键字搜索" @keyup.enter.native="paperSearch" />
                </el-form-item>
                <el-form-item style="float: right">
                  <el-button icon="el-icon-plus" type="primary" @click="addPaperTem">添加试卷</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" @click="paperSearch">搜索</el-button>
                </el-form-item>
              </el-form>
              <div class="card-content">
                <el-row>
                  <el-col v-loading="paperLoading" :span="24">
                    <el-table
                      :data="paperList"
                      stripe
                      style="width: 100%">
                      <el-table-column
                        prop="dName"
                        label="试卷名称"
                        width="200"
                        show-overflow-tooltip/>
                      <el-table-column
                        prop="dRemark"
                        label="试卷说明"
                        min-width="200"
                        show-overflow-tooltip/>
                      <el-table-column
                        label="是否公开"
                        width="100"
                        align="center"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span v-if="scope.row.dIspub===0">公开</span>
                          <span v-if="scope.row.dIspub===1">仅组织可见</span>
                          <span v-if="scope.row.dIspub===2">仅经销商可见</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="难度"
                        width="200"
                        align="center"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span style="color:#E6A23C;"><i class="el-icon-star-on"></i> {{scope.row.dDifficult}}.0</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="考试时长"
                        width="100"
                        align="center"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span>{{scope.row.dDuration}}分钟</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="username"
                        label="出题人"
                        width="100"
                        align="center"
                        show-overflow-tooltip/>
                      <el-table-column
                        prop="dTime"
                        label="添加时间"
                        width="200"
                        align="center"
                        show-overflow-tooltip/>
                      <el-table-column
                        label="总题数"
                        width="100"
                        fixed="right"
                        align="center"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span style="color: #409eff;font-weight: bold;">{{scope.row.dTotalCount}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="总分数"
                        align="center"
                        fixed="right"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span style="color: #f56c6c;font-weight: bold;">{{scope.row.dTotalScore}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="及格线"
                        width="100"
                        fixed="right"
                        align="center"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span style="color: #67C23A;font-weight: bold;">{{scope.row.dPassline}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="操作"
                        align="center"
                        width="300"
                        fixed="right">
                        <template slot-scope="scope">
                          <el-button icon="el-icon-document" size="mini" @click="paperPreviewVisible=true;getPaperProblem(scope.row)">预览</el-button>
                          <el-button icon="el-icon-edit" size="mini" @click="editPaperTem(scope.row)">修改</el-button>
                          <el-button icon="el-icon-delete" size="mini" @click="deletePaperTem(scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      v-if="paperTotal>0"
                      background
                      :current-page="paperCurrentPage"
                      :page-sizes="[20, 50, 100]"
                      :page-size="paperPageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="paperTotal"
                      @size-change="paperHandleSizeChange"
                      @current-change="paperHandleCurrentChange"/>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="问卷管理" name="second">
              <el-form :inline="true" size="small" @submit.native.prevent>
                <el-form-item label="标题">
                  <el-input v-model="researchSearchForm.title" clearable placeholder="关键字搜索" @keyup.enter.native="researchSearch" />
                </el-form-item>
                <el-form-item style="float: right">
                  <el-button icon="el-icon-plus" type="primary" @click="addResearchTem">添加问卷</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" @click="researchSearch">搜索</el-button>
                </el-form-item>
              </el-form>
              <div class="card-content">
                <el-row>
                  <el-col v-loading="researchLoading" :span="24">
                    <el-table
                      :data="researchList"
                      stripe
                      style="width: 100%">
                      <el-table-column
                        prop="title"
                        label="问卷标题"
                        width="200"
                        show-overflow-tooltip/>
                      <el-table-column
                        prop="desc"
                        label="问卷说明"
                        min-width="200"
                        show-overflow-tooltip/>
                      <el-table-column
                        label="是否公开"
                        width="100"
                        align="center"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span v-if="scope.row.ispub===0">公开</span>
                          <span v-if="scope.row.ispub===1">仅组织可见</span>
                          <span v-if="scope.row.ispub===2">仅经销商可见</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="username"
                        label="创建人"
                        width="100"
                        align="center"
                        show-overflow-tooltip/>
                      <el-table-column
                        prop="time"
                        label="添加时间"
                        width="200"
                        align="center"
                        show-overflow-tooltip/>
                      <el-table-column
                        label="操作"
                        align="center"
                        fixed="right"
                        width="300">
                        <template slot-scope="scope">
                          <el-button icon="el-icon-document" size="mini" @click="researchPreviewVisible=true;getResearchTopic(scope.row)">预览</el-button>
                          <el-button icon="el-icon-edit" size="mini" @click="editResearchTem(scope.row)">修改</el-button>
                          <el-button icon="el-icon-delete" size="mini" @click="deleteResearchTem(scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      v-if="researchTotal>0"
                      background
                      :current-page="researchCurrentPage"
                      :page-sizes="[20, 50, 100]"
                      :page-size="researchPageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="researchTotal"
                      @size-change="researchHandleSizeChange"
                      @current-change="researchHandleCurrentChange"/>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="paperDialogTitle"
      :visible.sync="paperDialogVisible"
      width="90%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :loading="paperLoading">
      <el-row>
        <el-col :span="16">
          <el-form ref="paperAddForm" :model="paperAddForm" :rules="paperRules" label-position="right" label-width="100px" size="small">
            <el-form-item label="试卷名称" prop="name">
              <el-input v-model="paperAddForm.name" clearable maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="试卷说明" prop="remark">
              <el-input
                v-model="paperAddForm.remark"
                maxlength="200"
                type="textarea"
                :rows="3"
                clearable
                show-word-limit/>
            </el-form-item>
            <el-form-item label="是否公开" prop="ispub">
              <el-radio v-model="paperAddForm.ispub" :label="0">公开</el-radio>
              <el-radio v-model="paperAddForm.ispub" :label="1">组织可见</el-radio>
              <el-radio v-model="paperAddForm.ispub" :label="2">经销商可见</el-radio>
            </el-form-item>
            <el-form-item label="难度" prop="difficult">
              <el-rate v-model="paperAddForm.difficult" style="padding-top: 7px" />
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="及格线" prop="passline">
                  <el-input v-model="paperAddForm.passline" placeholder="请输入分数">
                    <template slot="append">分</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="考试时长" prop="duration">
              <el-input-number v-model="paperAddForm.duration" :min="1" :max="999" ></el-input-number>（分钟）
            </el-form-item>
            <el-card
              v-for="(problem,index) in paperAddForm.problemForm"
              body-style="padding: 20px 20px 20px 0"
              style="margin-bottom: 30px">
              <div slot="header" class="clearfix">
                <span>试题{{ problem.xuhao }}</span>
                <el-button style="float: right; padding: 3px 0" type="text" size="mini" icon="el-icon-delete" @click.prevent="deletePaperProblem(index)">删除试题</el-button>
              </div>
              <el-form-item label="试题类型" :prop="'problemForm.'+index+'.type'" :rules="{required: true, message: '请选择试题类型', trigger: 'change'}">
                <el-select v-model="problem.type" style="width: 120px" filterable @change="calNumber(index,problem.type)">
                  <el-option v-for="item in paperTypeList" :label="item.label" :value="item.type" />
                </el-select>
              </el-form-item>
              <el-form-item label="试题分数" :prop="'problemForm.'+index+'.score'" :rules="{required: true, message: '请输入试题分数', trigger: 'blur'}">
                <el-input-number v-model="problem.score" step-strictly :min="0" clearable @change="calScore" type="number" />
              </el-form-item>
              <el-form-item label="题干内容" :prop="'problemForm.'+index+'.title'" :rules="{required: true, message: '请输入试题题干', trigger: 'blur'}">
                <el-input
                  v-model="problem.title"
                  maxlength="200"
                  type="textarea"
                  :rows="3"
                  clearable
                  show-word-limit/>
              </el-form-item>
              <el-form-item label="试题图片">
                <MultiImg :key="problem.imgkey" v-model="problem.imgs" :size="'sm'" :old="problem.oldImgList" /><!--<i class="el-icon-info" style="margin-top: 7px" /><el-tag icon="el-icon-info" style="margin-top: 7px;margin-left: 5px">上传完图片后可拖拽图片设置展示顺序</el-tag>-->
              </el-form-item>
              <el-form-item v-if="problem.type===0" label="试题选项" :prop="'problemForm.'+index+'.option'" :rules="{required: true, message: '请选择试题选项', trigger: 'blur'}">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addPaperOption(index)">添加选项</el-button><i class="el-icon-info" style="margin-left: 10px;margin-right: 5px" /><el-tag>单选题、多选题至少要有两个选项，选中即为正确选项</el-tag>
                <el-form-item
                  v-for="(opt, index2) in problem.option"
                  v-model="problem.option[index2]"
                  style="margin-top: 20px"
                  :prop="'problemForm.'+index+'.option.' + index2 + '.val'"
                  :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}">
                  <el-radio v-model="problem.trueOption" :label="opt.oxuhao">
                    <el-input v-model="opt.val" maxlength="100" placeholder="请输入选项内容" style="width: 250px"/>
                    <i v-if="opt.oxuhao>2" class="el-icon-delete" @click.prevent="deletePaperOption(index,index2)"></i>
                  </el-radio>
                </el-form-item>
              </el-form-item>
              <el-form-item v-if="problem.type===1" label="试题选项" :prop="'problemForm.'+index+'.option'" :rules="{required: true, message: '请选择试题选项', trigger: 'blur'}">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addPaperOption(index)">添加选项</el-button><i class="el-icon-info" style="margin-left: 10px;margin-right: 5px" /><el-tag>单选题、多选题至少要有两个选项，选中即为正确选项</el-tag>
                <el-form-item
                  v-for="(opt, index2) in problem.option"
                  v-model="problem.option[index2]"
                  style="margin-top: 20px"
                  :prop="'problemForm.'+index+'.option.' + index2 + '.val'"
                  :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}">
                  <el-checkbox-group v-model="problem.trueOptions" :min="2">
                    <el-checkbox :label="opt.oxuhao" clearable placeholder="请输入选项内容">
                      <el-input v-model="opt.val" style="width: 250px" :prop="opt.name" :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}" maxlength="100" placeholder="请输入选项内容" />
                      <i v-if="opt.oxuhao>2" class="el-icon-delete" @click.prevent="deletePaperOption(index,index2)"></i>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form-item>
              <el-form-item v-if="problem.type===2" label="试题选项">
                <el-radio v-model="problem.trueOption" :label="1">正确</el-radio>
                <el-radio v-model="problem.trueOption" :label="2">错误</el-radio>
              </el-form-item>
            </el-card>
          </el-form>
        </el-col>
        <el-col :span="8">
          <el-card style="width: calc(30% - 50px);position:fixed;top:24vh;right: calc(5% + 40px);font-size: 13px">
            <div style="padding-bottom: 20px">
              <span style="font-weight: bold">试卷信息</span>
            </div>
            <div style="margin-bottom: 10px">
              <span style="color:#99a9bf">出题人：</span>
              <span style="margin-right: 6px">{{ user.dName }}</span>
            </div>
            <div style="margin-bottom: 10px">
              <span style="color:#99a9bf">总分数：</span>
              <span style="color:#4b9af8;margin-right: 6px;font-weight: bold">{{ score }}</span>
              <span style="color:#99a9bf;margin-left: 20px">总题数：</span>
              <span style="color:#4b9af8;margin-right: 6px;font-weight: bold">{{ count }}</span>
            </div>
            <div style="margin-bottom: 20px">
              <span style="color:#99a9bf">单选题：</span>
              <span style="color:#4b9af8;margin-right: 6px;font-weight: bold">{{ type1 }}</span>
              <span style="color:#99a9bf;margin-left: 20px">多选题：</span>
              <span style="color:#4b9af8;margin-right: 6px;font-weight: bold">{{ type2 }}</span>
              <span style="color:#99a9bf;margin-left: 20px">判断题：</span>
              <span style="color:#4b9af8;margin-right: 6px;font-weight: bold">{{ type3 }}</span>
            </div>
            <div>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addPaperProblem">添加试题</el-button>
              <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="paperBtnLoading" @click="submitPaperTem">提交</el-button>
              <el-button size="mini" icon="el-icon-document" @click="showAddPaper">预览</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="试卷预览"
      :visible.sync="paperPreviewVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <h3 align="center">{{ paperAddForm.name }}</h3>
      <div style="width: 100%;text-align: center;color: #666666;margin-bottom: 10px">{{ paperAddForm.remark }}</div>
      <div align="center"><span>出题人：{{ username }}</span><span style="margin-left: 20px">总题数：{{ count }}</span><span style="margin-left: 20px">总分数：{{ score }}</span></div>
      <div v-for="problem in paperAddForm.problemForm" style="margin-left: 50px;margin-bottom: 30px">
        <h4>{{ problem.xuhao }}、{{ problem.title }}（
          <span v-if="problem.type===0">单选题</span>
          <span v-if="problem.type===1">多选题</span>
          <span v-if="problem.type===2">判断题</span>
          ,{{ problem.score }}分）
        </h4>
        <div>
          <el-image
            v-for="img in problem.oldImgList"
            fit="cover"
            style="width: 60px; height: 60px;margin-right: 10px;"
            :src="img.url"
            :preview-src-list="problem.oldImgList.map(e=>e.url)"/>
        </div>
        <div v-if="problem.type===0">
          <div v-for="option in problem.option" style="margin-top: 20px;">
            <span :style="problem.trueOption===option.oxuhao?'color: #67C23A;font-weight: bold':''"><i :class="problem.trueOption===option.oxuhao?'el-icon-success':'el-icon-error'"></i> {{option.val}}</span>
          </div>
        </div>
        <div v-if="problem.type===1">
          <div v-for="option in problem.option" style="margin-top: 20px">
            <span :style="problem.trueOptions.indexOf(option.oxuhao)>=0?'color: #67C23A;font-weight: bold':''"><i :class="problem.trueOptions.indexOf(option.oxuhao)>=0?'el-icon-success':'el-icon-error'"></i> {{option.val}}</span>
          </div>
        </div>
        <div v-if="problem.type===2">
          <span :style="problem.trueOption===1?'color: #67C23A;font-weight: bold':''"><i :class="problem.trueOption===1?'el-icon-success':'el-icon-error'"></i> 正确</span>
          <span :style="`margin-left: 20px;${problem.trueOption===2?'color: #67C23A;font-weight: bold':''}`"><i :class="problem.trueOption===2?'el-icon-success':'el-icon-error'"></i> 错误</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="researchDialogTitle"
      :visible.sync="researchDialogVisible"
      width="90%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :loading="researchLoading">
      <el-row>
        <el-col :span="16">
          <el-form ref="researchAddForm" :model="researchAddForm" :rules="researchRules" label-position="right" label-width="100px" size="small">
            <el-form-item label="问卷标题" prop="title">
              <el-input v-model="researchAddForm.title" clearable maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="问卷说明" prop="desc">
              <el-input
                v-model="researchAddForm.desc"
                maxlength="200"
                type="textarea"
                :rows="3"
                clearable
                show-word-limit/>
            </el-form-item>
            <el-form-item label="是否公开" prop="ispub">
              <el-radio v-model="researchAddForm.ispub" :label="0">公开</el-radio>
              <el-radio v-model="researchAddForm.ispub" :label="1">组织可见</el-radio>
              <el-radio v-model="researchAddForm.ispub" :label="2">经销商可见</el-radio>
            </el-form-item>
            <el-card
              v-for="(topic,index) in researchAddForm.topicForm"
              body-style="padding: 20px 20px 20px 0"
              style="margin-bottom: 30px">
              <div slot="header" class="clearfix">
                <span>题目{{ topic.xuhao }}</span>
                <el-button style="float: right; padding: 3px 0" type="text" size="mini" icon="el-icon-delete" @click.prevent="deleteTopic(index)">删除题目</el-button>
              </div>
              <el-form-item label="题目类型" :prop="'topicForm.'+index+'.type'" :rules="{required: true, message: '请选择试题类型', trigger: 'change'}">
                <el-select v-model="topic.type" style="width: 120px">
                  <el-option v-for="item in researchTypeList" :label="item.label" :value="item.type" />
                </el-select>
              </el-form-item>
              <el-form-item label="是否必填" :prop="'topicForm.'+index+'.isreq'" :rules="{required: true, message: '请选择是否必填', trigger: 'change'}">
                <el-radio v-model="topic.isreq" :label="1">必填</el-radio>
                <el-radio v-model="topic.isreq" :label="0">非必填</el-radio>
              </el-form-item>
              <el-form-item label="题目标题" :prop="'topicForm.'+index+'.title'" :rules="{required: true, message: '请输入问卷调查题目标题', trigger: 'blur'}">
                <el-input
                  v-model="topic.title"
                  maxlength="200"
                  type="textarea"
                  :rows="3"
                  clearable
                  show-word-limit/>
              </el-form-item>
              <el-form-item v-if="topic.type===1" label="问卷选项" :prop="'topicForm.'+index+'.option'" :rules="{required: true, message: '请选择选项', trigger: 'blur'}">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addResearchOption(index)">添加选项</el-button>
                <el-form-item
                  v-for="(opt, index2) in topic.option"
                  v-model="topic.option[index2]"
                  style="margin-top: 20px"
                  :prop="'topicForm.'+index+'.option.' + index2 + '.name'"
                  :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}">
                  <el-radio disabled :label="topic.option[index2].name" :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}">
                    <el-input v-model="opt.name" maxlength="100" style="width: 250px" clearable placeholder="请输入选项内容" />
                    <i v-if="index2>1" class="el-icon-delete" @click.prevent="deleteResearchOption(index,index2)"></i>
                  </el-radio>
                </el-form-item>
              </el-form-item>
              <el-form-item v-if="topic.type===2" label="问卷选项" :prop="'topicForm.'+index+'.option'" :rules="{required: true, message: '请选择选项', trigger: 'blur'}">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addResearchOption(index)">添加选项</el-button>
                <el-form-item
                  v-for="(opt, index2) in topic.option"
                  v-model="topic.option[index2]"
                  style="margin-top: 20px"
                  :prop="'topicForm.'+index+'.option.' + index2 + '.name'"
                  :rules="{required: true, message: '请输入选项内容', trigger: 'blur'}">
                  <el-checkbox-group v-model="topic.trueOptions">
                    <el-checkbox disabled clearable placeholder="请输入选项内容">
                      <el-input v-model="opt.name" maxlength="40" style="width: 250px" clearable placeholder="请输入选项内容" />
                      <i v-if="index2>1" class="el-icon-delete" @click.prevent="deleteResearchOption(index,index2)"></i>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-form-item>
              <el-form-item v-if="topic.type===3">
                <el-input
                  placeholder="用户填写"
                  type="textarea"
                  :rows="3"
                  disabled
                  show-word-limit/>
              </el-form-item>
              <el-form-item v-if="topic.type===4">
                <el-rate :value="1" disabled></el-rate>
              </el-form-item>
            </el-card>
          </el-form>
        </el-col>
        <el-col :span="8">
          <el-card style="width: calc(30% - 50px);position:fixed;top:24vh;right: calc(5% + 40px);font-size: 13px">
            <div align="center">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addTopic">添加题目</el-button>
              <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="researchBtnLoading" @click="submitResearchTem">提交</el-button>
              <el-button size="mini" icon="el-icon-document" @click="researchPreviewVisible=true;username=user.name">预览</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="问卷预览"
      :visible.sync="researchPreviewVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <h4 align="center">{{ researchAddForm.title }}</h4>
      <div style="width: 100%;text-align: center;color: #666666;margin-bottom: 10px">{{ researchAddForm.desc }}</div>
      <div v-for="topic in researchAddForm.topicForm" style="margin-left: 50px">
        <h4><span style="color: #e01222" v-if="topic.isreq===1">*</span>{{ topic.xuhao }}、{{ topic.title }}（
          <span v-if="topic.type===1">单选</span>
          <span v-if="topic.type===2">多选</span>
          <span v-if="topic.type===3">输入框</span>
          <span v-if="topic.type===4">评分</span>
          ,<span v-if="topic.isreq===0">非必填）</span>
          <span v-if="topic.isreq===1">必填）</span>
        </h4>
        <div v-if="topic.type===1 || topic.type===2">
          <div v-for="option in topic.option" style="margin-top: 20px">
            <span style="color: #67C23A;font-weight: bold"><i class="el-icon-circle-check" style="margin-right: 10px"></i>
              {{ option.name }}
            </span>
          </div>
        </div>
        <div v-if="topic.type===3">
          <el-input
            placeholder="用户填写"
            type="textarea"
            :rows="3"
            disabled
            show-word-limit/>
        </div>
        <div v-if="topic.type===4">
          <el-rate :value="1" disabled></el-rate>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  addOrEditPaper, addOrEditResearch,
  deletePaper, deleteResearch,
  getPapers,
  getProblemListById, getResearchListGxj, getTopicListById
} from '@/api/infoManage'
import MultiImg from '@/components/upload/MultiImg'
import qs from 'qs'

export default {
  name: 'zlgl',
  components: { MultiImg },
  data() {
    const validatePassline = (rule, value, callback) => {
      if (value !== null && value !== '' && value !== undefined) {
        const r = /^\+?[1-9][0-9]*$/ // 正整数
        if (!r.test(value)) {
          callback(new Error('请输入正确的正整数'))
        } else {
          if (parseInt(value) >= 0) {
            callback()
          } else {
            callback(new Error('请输入大于或等于0的正整数'))
          }
        }
      } else {
        callback(new Error('请输入及格线'))
      }
    }
    return {
      activeName: 'first',
      /* 试卷数据 */
      paperSearchForm: {
        name: ''
      },
      paperLoading: false,
      paperPreviewVisible: false,
      paperDialogTitle: '',
      paperDialogVisible: false,
      paperBtnLoading: false,
      paperList: [],
      paperCurrentPage: 1,
      paperPageSize: 20,
      paperTotal: 0,
      paperAddForm: {
        paperid: 0,
        name: '',
        remark: '',
        ispub: 0,
        totalCount: null,
        totalScore: null,
        difficult: 1,
        duration: 1,
        passline: null,
        problemForm: []
      },
      problemForm: [{
        type: null,
        score: null,
        title: '',
        xuhao: 0,
        imgs: [],
        imgkey: '',
        oldImgList: [],
        trueOption: null,
        trueOptions: [],
        optioncount: 1,
        option: [{
          oxuhao: null,
          val: ''
        }]
      }],
      paperRules: {
        name: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
        ispub: [{ required: true, message: '请选择是否公开', trigger: 'change' }],
        difficult: [{ required: true, message: '请选择难度', trigger: 'change' }],
        duration: [{ required: true, message: '请输入考试时长', trigger: 'change' }],
        passline: [{ required: true, trigger: 'blur', validator: validatePassline }],
        remark: [{ required: true, message: '请输入试卷说明', trigger: 'blur' }]
      },
      researchSearchForm: {
        title: ''
      },
      researchLoading: false,
      researchPreviewVisible: false,
      researchDialogTitle: '',
      researchDialogVisible: false,
      researchBtnLoading: false,
      researchList: [],
      researchCurrentPage: 1,
      researchPageSize: 20,
      researchTotal: 0,
      researchAddForm: {
        rid: 0,
        title: '',
        desc: '',
        ispub: '',
        topicForm: []
      },
      topicForm: [{
        xuhao: 0,
        type: 1,
        title: '',
        isreq: 0,
        trueOption: null,
        trueOptions: [],
        option: [{
          name: ''
        }]
      }],
      researchRules: {
        title: [{ required: true, message: '请输入问卷名称', trigger: 'blur' }],
        ispub: [{ required: true, message: '请选择是否公开', trigger: 'change' }],
        desc: [{ required: true, message: '请输入问卷说明', trigger: 'change' }]
      },
      paperTypeList: [{
        type: 0,
        label: '单选题'
      }, {
        type: 1,
        label: '多选题'
      }, {
        type: 2,
        label: '判断题'
      }],
      researchTypeList: [{
        type: 1,
        label: '单选'
      }, {
        type: 2,
        label: '多选'
      }, {
        type: 3,
        label: '输入框'
      }, {
        type: 4,
        label: '评分'
      }],
      username: '',
      count: 0,
      score: 0,
      type1: 0,
      type2: 0,
      type3: 0
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getPaperData()
    this.getResearchData()
  },
  methods: {
    paperSearch() {
      this.paperCurrentPage = 1
      this.getPaperData()
    },
    researchSearch() {
      this.researchCurrentPage = 1
      this.getResearchData()
    },
    getPaperData() {
      this.paperLoading = true
      const data = {
        page: this.paperCurrentPage,
        limit: this.paperPageSize,
        name: this.paperSearchForm.name,
        groupid: this.user.dGroupid
      }
      getPapers(data).then(response => {
        this.paperList = response.data
        this.paperTotal = response.total
        this.paperLoading = false
      }).catch(() => {
        this.paperLoading = false
      })
    },
    getResearchData() {
      this.researchLoading = true
      const data = {
        page: this.researchCurrentPage,
        limit: this.researchPageSize,
        title: this.researchSearchForm.title,
        groupid: this.user.dGroupid
      }
      getResearchListGxj(data).then(response => {
        this.researchList = response.data
        this.researchTotal = response.total
        this.researchLoading = false
      }).catch(() => {
        this.researchLoading = false
      })
    },
    paperHandleSizeChange(val) {
      this.paperPageSize = val
      this.paperCurrentPage = 1
      this.getPaperData()
    },
    paperHandleCurrentChange(val) {
      this.paperCurrentPage = val
      this.getPaperData()
    },
    researchHandleSizeChange(val) {
      this.researchPageSize = val
      this.researchCurrentPage = 1
      this.getResearchData()
    },
    researchHandleCurrentChange(val) {
      this.researchCurrentPage = val
      this.getResearchData()
    },
    addPaperTem() {
      this.paperAddForm.problemForm = []
      this.count = 0
      this.score = 0
      this.type1 = 0
      this.type2 = 0
      this.type3 = 0
      this.paperDialogTitle = '添加试卷'
      this.paperDialogVisible = true
      this.paperAddForm.name = ''
      this.paperAddForm.remark = ''
      this.paperAddForm.paperid = 0
      this.paperAddForm.ispub = 0
      this.paperAddForm.difficult = 1
      this.paperAddForm.duration = 1
      this.paperAddForm.totalCount = null
      this.paperAddForm.totalScore = null
      this.paperAddForm.passline = null
      this.paperAddForm.testForm = []
    },
    editPaperTem(row) {
      if (!this.paperLoading) {
        this.paperLoading = true
        this.getPaperProblem(row)
        this.paperLoading = false
      }
      this.paperAddForm.paperid = row.dPaperid
      this.paperAddForm.remark = row.dRemark
      this.paperAddForm.name = row.dName
      this.paperAddForm.ispub = row.dIspub
      this.paperAddForm.difficult = row.dDifficult
      this.paperAddForm.duration = row.dDuration
      this.paperAddForm.passline = row.dPassline
      this.paperDialogTitle = '修改试卷'
      this.paperDialogVisible = true
    },
    deletePaperTem(row) {
      this.$confirm('您确定要删除此试卷吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deletePaper({ paperid: row.dPaperid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getPaperData()
        })
      }).catch(() => {})
    },
    submitPaperTem() {
      if (!this.paperBtnLoading) {
        this.$refs['paperAddForm'].validate((valid) => {
          if (valid) {
            const check = []
            for (const problem of this.paperAddForm.problemForm) {
              if (problem.type === 1) {
                if (problem.trueOptions.length < 2) {
                  check.push(problem.xuhao)
                }
              }
            }
            if (this.paperAddForm.problemForm.length === 0) {
              this.$message.error('至少添加一个试题')
            } else if (check.length > 0) {
              this.$message.error('第' + check[0] + '题的多选题最少要选择两个正确答案,请细心检查多选题的选项')
              this.paperBtnLoading = false
            } else {
              this.paperBtnLoading = true
              const _problemList = []
              for (const p of this.paperAddForm.problemForm) {
                _problemList.push({
                  imgs: p.imgs,
                  option: p.option,
                  paperid: p.paperid,
                  score: p.score,
                  title: p.title,
                  trueOption: p.trueOption,
                  trueOptions: p.trueOptions,
                  type: p.type,
                  xuhao: p.xuhao
                })
              }
              const data = {
                paperid: this.paperAddForm.paperid,
                name: this.paperAddForm.name,
                ispub: this.paperAddForm.ispub,
                remark: this.paperAddForm.remark,
                difficult: this.paperAddForm.difficult,
                duration: this.paperAddForm.duration,
                totalCount: this.count,
                totalScore: this.score,
                passline: this.paperAddForm.passline,
                userid: this.user.dUserid,
                problemForm: qs.parse(_problemList)
              }
              addOrEditPaper(data).then(response => {
                this.$message({
                  message: response.msg,
                  type: 'success'
                })
                this.paperBtnLoading = false
                this.paperDialogVisible = false
                this.getPaperData()
              }).catch(() => {
                this.paperBtnLoading = false
              })
            }
          } else {
            return false
          }
        })
      }
    },
    addResearchTem() {
      this.count = 0
      this.researchDialogTitle = '添加问卷'
      this.researchDialogVisible = true
      this.researchAddForm.title = ''
      this.researchAddForm.desc = ''
      this.researchAddForm.rid = 0
      this.researchAddForm.ispub = 0
      this.researchAddForm.topicForm = []
    },
    editResearchTem(row) {
      this.researchDialogVisible = true
      if (!this.researchLoading) {
        this.researchLoading = true
        this.getResearchTopic(row)
        this.researchLoading = false
      }
      this.researchAddForm.rid = row.rid
      this.researchAddForm.desc = row.desc
      this.researchAddForm.title = row.title
      this.researchAddForm.ispub = row.ispub
      this.researchDialogTitle = '修改问卷'
    },
    deleteResearchTem(row) {
      this.$confirm('您确定要删除此问卷吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteResearch({ rid: row.rid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getResearchData()
        })
      }).catch(() => {})
    },
    submitResearchTem() {
      if (!this.researchBtnLoading) {
        this.$refs['researchAddForm'].validate((valid) => {
          if (valid) {
            if (this.researchAddForm.topicForm.length === 0) {
              this.$message.error('还未添加题目')
            } else {
              this.researchBtnLoading = true
              let topicList = ''
              topicList = qs.parse(this.researchAddForm.topicForm)
              const data = {
                rid: this.researchAddForm.rid,
                title: this.researchAddForm.title,
                ispub: this.researchAddForm.ispub,
                desc: this.researchAddForm.desc,
                userid: this.user.dUserid,
                topicForm: topicList
              }
              addOrEditResearch(data).then(response => {
                this.$message({
                  message: response.msg,
                  type: 'success'
                })
                this.researchBtnLoading = false
                this.researchDialogVisible = false
                this.getResearchData()
              }).catch(() => {
                this.researchBtnLoading = false
              })
            }
          } else {
            return false
          }
        })
      }
    },
    calScore(currentValue, oldValue) {
      const _score = this.score - parseInt(oldValue)
      this.score = _score + parseInt(currentValue)
    },
    calNumber(index, type) {
      if (type === 0) {
        this.paperAddForm.problemForm[index].trueOption = 1
      }
      if (type === 1) {
        this.paperAddForm.problemForm[index].trueOptions = [1, 2]
      }
      if (type === 2) {
        this.paperAddForm.problemForm[index].trueOption = 1
      }
      let count = 0
      let score = 0
      let type1 = 0
      let type2 = 0
      let type3 = 0
      for (const problem of this.paperAddForm.problemForm) {
        count++
        score = score + parseInt(problem.score)
        if (problem.type === 0) {
          type1++
        } else if (problem.type === 1) {
          type2++
        } else if (problem.type === 2) {
          type3++
        }
      }
      this.count = count
      this.score = score
      this.type1 = type1
      this.type2 = type2
      this.type3 = type3
    },
    getPaperProblem(data) {
      this.paperAddForm.problemForm = []
      this.problemForm = []
      this.paperAddForm.name = data.dName
      this.username = data.username
      this.paperAddForm.remark = data.dRemark
      this.paperLoading = true
      getProblemListById({ paperid: data.dPaperid }).then(response => {
        let index = 0
        let index2 = 0
        for (const problem of response.data) {
          this.problemForm.push({
            pid: problem.dPid,
            type: problem.dType,
            score: problem.dScore,
            title: problem.dTitle,
            xuhao: index + 1,
            trueOption: null,
            trueOptions: [],
            optioncount: problem.optioncount,
            imgkey: new Date().getTime().toString() + index,
            imgs: [],
            oldImgList: [],
            option: []
          })
          for (const img of problem.imgList) {
            this.problemForm[index].oldImgList.push({
              id: img.dImgid,
              url: img.img_url
            })
          }
          for (const option of problem.optionList) {
            this.problemForm[index].option.push({
              oxuhao: index2 + 1,
              val: option.dVal,
              pid: option.dPid,
              poid: option.dPoid
            })
            index2++
            if (problem.dType === 0 || problem.dType === 2) {
              if (option.dIstrue === 1) {
                this.problemForm[index].trueOption = option.dXuhao
              }
            }
            if (problem.dType === 1) {
              if (option.dIstrue === 1) {
                this.problemForm[index].trueOptions.push(option.dXuhao)
              }
            }
          }
          this.paperAddForm.problemForm.push(this.problemForm[index])
          index++
          index2 = 0
        }
        this.calNumber()
        this.paperLoading = false
      })
    },
    getResearchTopic(data) {
      this.researchLoading = true
      this.researchAddForm.topicForm = []
      this.topicForm = []
      this.researchAddForm.desc = data.desc
      this.researchAddForm.title = data.title
      getTopicListById({ rid: data.rid }).then(response => {
        let index = 0
        for (const topic of response.data) {
          this.topicForm.push({
            xuhao: index + 1,
            type: topic.type,
            title: topic.title,
            isreq: topic.isreq,
            optioncount: topic.optioncount,
            option: []
          })
          for (const option of topic.optionList) {
            if (topic.type === 1 || topic.type === 2) {
              this.topicForm[index].option.push({
                name: option.name
              })
            }
          }
          this.researchAddForm.topicForm.push(this.topicForm[index])
          index++
          this.count = index
        }
        this.researchLoading = false
      })
    },
    addPaperProblem() {
      this.paperAddForm.problemForm.push({
        paperid: '',
        type: 0,
        score: 0,
        title: '',
        xuhao: this.count + 1,
        imgs: [],
        imgkey: new Date().getTime().toString(),
        oldImgList: [],
        optioncount: 2,
        trueOption: 1,
        trueOptions: [1, 2],
        option: [{
          val: '',
          oxuhao: 1
        }, {
          val: '',
          oxuhao: 2
        }]
      })
      this.calNumber()
    },
    deletePaperProblem(index) {
      this.$confirm('您确定要删除此试题吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        if (index !== -1) {
          this.paperAddForm.problemForm.splice(index, 1)
          this.count--
          this.calNumber()
        }
      }).catch(() => {
      })
    },
    addPaperOption(index2) {
      this.paperAddForm.problemForm[index2].option.push({
        val: '',
        oxuhao: (this.paperAddForm.problemForm[index2].optioncount)++ + 1
      })
    },
    deletePaperOption(index, index2) {
      if (this.paperAddForm.problemForm[index].trueOptions.length <= 2 &&
        this.paperAddForm.problemForm[index].trueOptions.indexOf(this.paperAddForm.problemForm[index].option[index2].oxuhao) >= 0) {
        return
      }
      this.$confirm('您确定要删除此选项吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        if (index2 !== -1) {
          this.paperAddForm.problemForm[index].option.splice(index2, 1)
          this.paperAddForm.problemForm[index].optioncount--
        }
      }).catch(() => {
      })
    },
    addTopic() {
      this.researchAddForm.topicForm.push({
        rid: 0,
        type: 1,
        title: '',
        isreq: 0,
        xuhao: this.count + 1,
        trueOption: 1,
        trueOptions: [1, 2],
        option: [{
          name: ''
        }, {
          name: ''
        }]
      })
      this.count++
    },
    deleteTopic(index) {
      this.$confirm('您确定要删除此试题吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        if (index !== -1) {
          this.researchAddForm.topicForm.splice(index, 1)
          this.count--
        }
      }).catch(() => {
      })
    },
    addResearchOption(index2) {
      this.researchAddForm.topicForm[index2].option.push({
        name: ''
      })
    },
    deleteResearchOption(index, index2) {
      this.$confirm('您确定要删除此选项吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        if (index2 !== -1) {
          this.researchAddForm.topicForm[index].option.splice(index2, 1)
        }
      }).catch(() => {
      })
    },
    showAddPaper() {
      this.username = this.user.dName
      this.paperPreviewVisible = true
    }
  }
}
</script>

<style scoped>

</style>
